import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationSavedFilterCreateArgs, MutationSavedFilterDeleteArgs, SavedFilter } from "types/generated";

type SaveViewData = {
  savedFilterCreate: Pick<SavedFilter, "id" | "name" | "data" | "isPublic" | "createdBy">;
};

export const SAVE_VIEW: TypedDocumentNode<SaveViewData, MutationSavedFilterCreateArgs> = gql`
  mutation SaveView($input: SavedFilterInput!) {
    savedFilterCreate(input: $input) {
      id
      name
      data
      isPublic
      createdBy
    }
  }
`;

type SavedViewsListData = {
  savedFilters: Pick<
    SavedFilter,
    "id" | "name" | "data" | "isPublic" | "createdBy" | "type"
  >[];
};

type SavedViewsListVariables = {
  type?: string | null;
};

export const SAVED_VIEWS_LIST: TypedDocumentNode<SavedViewsListData, SavedViewsListVariables> = gql`
  query SavedViewsList($type: String) {
    savedFilters(type: $type) {
      id
      name
      data
      isPublic
      createdBy
      type
    }
  }
`;

type UpdateViewData = {
  savedFilterUpdate: Pick<SavedFilter, "id" | "data" | "name">;
};

type UpdateViewVariables = {
  id: string;
  isPublic: boolean;
  data?: string | null;
  name?: string | null;
};

export const UPDATE_VIEW: TypedDocumentNode<UpdateViewData, UpdateViewVariables> = gql`
  mutation UpdateView($id: ID!, $isPublic: Boolean!, $data: String, $name: String) {
    savedFilterUpdate(id: $id, isPublic: $isPublic, data: $data, name: $name) {
      id
      data
      name
    }
  }
`;

type RemoveViewData = {
  savedFilterDelete: Pick<SavedFilter, "id"> | null;
};

export const REMOVE_VIEW: TypedDocumentNode<RemoveViewData, MutationSavedFilterDeleteArgs> = gql`
  mutation RemoveView($id: ID!) {
    savedFilterDelete(id: $id) {
      id
    }
  }
`;
